import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import Overview from './views/Overview'
import { CaptableManagementBreadcrumbs } from './core/_constants'
import Captable from './views/Captable'
import Scenarios from './views/Scenarios'
import Timeline from './views/Timeline'
import WaterfallDetails from './components/WaterfallDetails'
import FinancialDetails from './components/FinancialDetails'
import CreateNewScenario from './views/CreateNewScenario'

export const CaptableManagementRoutes = () => {
    const { formatMessage } = useIntl()
    const { CaptableManagementBreadCrumbs } = CaptableManagementBreadcrumbs()

    return (
        <div className='mt-3'>
            <Routes>
                <Route
                    path='overview'
                    element={
                        <>
                            <Overview />
                        </>
                    }
                />
                <Route
                    path='captable'
                    element={
                        <>
                            <Captable />
                        </>
                    }
                />
                <Route
                    path='scenarios'
                    element={
                        <>
                            <Scenarios />
                        </>
                    }
                />
                <Route
                    path='scenarios/waterfall-details'
                    element={
                        <>
                            <WaterfallDetails />
                        </>
                    }
                />
                <Route
                    path='scenarios/financial-details/:scenarioId'
                    element={
                        <>
                            <FinancialDetails />
                        </>
                    }
                />
                <Route
                    path='scenarios/create-new-scenario'
                    element={
                        <>
                            <CreateNewScenario />
                        </>
                    }
                />
                <Route
                    path='scenarios/update/:scenarioId'
                    element={
                        <>
                            <CreateNewScenario />
                        </>
                    }
                />
                <Route
                    path='timeline'
                    element={
                        <>
                            <PageTitle
                                breadcrumbs={CaptableManagementBreadCrumbs}
                                description={formatMessage({ id: 'Timeline' })}
                            >
                                {formatMessage({ id: 'Cap table Management' })}
                            </PageTitle>
                            <Timeline />
                        </>
                    }
                />
            </Routes>
        </div>
    )
}
